import { styled } from '@mui/material';
import React from 'react';

const StyledContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    columnGap: 7,
    '*': {
        mixBlendMode: 'unset !important',
    },
    '.outOfStock-pill': {
        textWrap: 'nowrap',
        borderRadius: 25,
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        display: 'flex',
        alignItems: 'center',
        ':hover': {
            cursor: 'default',
        },
    },
}));
const StyledOutOfStockPill = styled('div')(({ theme }) => {
    var _a, _b;
    return ({
        borderRadius: '999px',
        color: ((_a = theme.vars.globalComponentPresets) === null || _a === void 0 ? void 0 : _a.pill.outOfStock.contrastText) ||
            theme.vars.palette.text.primary,
        backgroundColor: (_b = theme.vars.globalComponentPresets) === null || _b === void 0 ? void 0 : _b.pill.outOfStock.main,
        display: 'flex',
        width: 'fit-content',
    });
});
const OutOfStockPill = ({ containerStyle: containerStyleOverride = {}, pillContainerStyle = {}, baseFontSize = 14, }) => {
    const pillDefaultPadding = {
        paddingTop: baseFontSize / 3,
        paddingLeft: baseFontSize * 0.95,
        paddingBottom: baseFontSize / 3,
        paddingRight: baseFontSize * 0.95,
    };
    return (React.createElement(StyledContainer, { style: Object.assign({ display: 'block', width: 'fit-content' }, containerStyleOverride) },
        React.createElement(StyledOutOfStockPill, null,
            React.createElement("div", { className: "outOfStock-pill", style: Object.assign(Object.assign(Object.assign({}, pillDefaultPadding), pillContainerStyle), { fontWeight: 600 }) }, 'Sold out'))));
};

export { OutOfStockPill };
//# sourceMappingURL=OutOfStockPill.js.map
